import { Component, inject, Input, OnInit } from '@angular/core';
import {
  ImageFactory,
  PictureTagInfoInterface,
  PictureTagRenditionInterface,
  WagtailPageContentElementInterface
} from "@gea-waldviertler-website/gea-models";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

@Component({
    selector: 'wagtail-page-element-image',
    templateUrl: './image.component.html',
    standalone: false
})
export class WagtailImageComponent implements OnInit {
  @Input() definition?: WagtailPageContentElementInterface<PictureTagInfoInterface>
  @Input() image?: PictureTagInfoInterface
  @Input() class?: string
  @Input() width?: number
  @Input() height?: number
  @Input() sizes?: string
  @Input() loading: 'lazy' | 'eager' = 'lazy'
  @Input() fetchpriority?: 'high' | 'low' | 'auto'
  
  imageRoot: string
  private envService = inject(EnvService)

  constructor() {
    this.imageRoot = this.envService.config.cmsMediaUrl
  }

  ngOnInit(): void {
    if (this.definition) {
      this.image = (this.definition.value as PictureTagInfoInterface)
    }
  }

  getFallbackSrc(): string {
    if (!this.image) return '';
    let image: PictureTagRenditionInterface | undefined
    const targetWidth = this.width || 600
    image = ImageFactory.getBestNonWebp(this.image, targetWidth)

    return this.imageRoot + (image ? image.path.replace(/^\/media/, '') : this.image.path)
  }

  getWebpSrcset(): string {
    if (!this.image) return '';
    const webps = ImageFactory.getWebpRenditions(this.image)
    return webps.map(r => `${this.imageRoot}${r.path.replace(/^\/media/, '')} ${r.width}w`).join(', ')
  }

  getSizes(): string {
    if (this.sizes) return this.sizes
    if (this.loading === 'lazy') return `auto, ${this.width ? `${this.width}px` : '100vw'}`
    return this.width ? `${this.width}px` : '100vw'
  }

  getAlt(): string {
    if (this.image?.alt && this.image.alt.length) return this.image?.alt?.join(' ')
    if (this.image?.title) return this.image?.title
    return 'Bild'
  }

  getTitle(): string {
    return this.image?.title ?? ''
  }

  getImgClasses(): string {
    return `d-block w-100 h-100 ${this.class ?? ''}`.trim()
  }
}
